import React from "react";
import { Container } from "react-bootstrap";

const Blog2 = () => {
  return (
    <div>
      <div className="blog">
        <Container>
          <h2
            style={{ marginTop: "85px" }}
            className="mb-5 text-center project-title"
          >
            Is React Good For SEO?
          </h2>
          <div style={{ justifyContent: "center" }} className="d-flex">
            <img
              className="img-fluid"
              src="https://i.ibb.co/6t8Qfwt/SEO-challenge-in-Reactjs.jpg"
              alt="css-flexbox"
            />
          </div>
          <br />
          <article>
            <p>
              Is react good for <b>SEO?</b> The answer is not straightforward.
              It depends on how you build your website. If you build a simple
              react website. Then it will be very bad for SEO. Though you use
              meta tag, alt tag, and complete every on-page SEO, it won t be
              good for SEO at all.
            </p>
            <br />
            <p>
              We know that React is a very popular and powerful framework and it
              is powered by Facebook. But it does a very bad job on SEO.
            </p>
            <br />
            <p>
              Why? Now you know that react is bad for SEO. So, there are so many
              questions in your mind right now. But Why? Or Should we avoid
              React?
            </p>
            <br />
            <p>
              The simple answer is <b>No</b>.
            </p>
            <br />
            <p>
              It just has not happened with React Js. It happens with every
              other javascript or virtual dom-based framework.
            </p>
            <br />
            <p>
              <b>If you need to know why? Then stay with me</b>
            </p>
            <p>
              First, you need to understand what is SEO and how does it work?
              <b>SEO</b> means search engine optimization. The website is
              generally optimized by some algorithm based on some rule. And the
              most important one is &lt;meta&gt; tag.
            </p>
            <br />
            <p>
              Actually, the content inside the meta tag didn't show on the
              website. It helps search engines for SEO. And the search engine
              scrolls through all of the pages of a website and finds meta tags
              to optimize the website. But the React website load HTML
              dynamically so if any visitor didn t load the website. The HTML is
              not rendered on the website. So, the search engine can not
              understand the content.
            </p>
            <br />
            <p>
              Nowadays most of the search engines are optimizing a website with
              javascript rendering and it helps sometimes but most of the time
              the static website rank first.
            </p>
            <br />
            <p>
              <b>Is there any solution?</b>
            </p>
            <p>
              Yes. There are a lot of options for SEO a React Js website. If we
              somehow can manage the website to pre-render the HTML element like
              a static website then that will be very easy for search engines to
              understand the website and for SEO.
            </p>
            <br />
            <p>
              <b>How we can do that?</b>
            </p>
            <p>
              There are many ways to do that. One is Server-Side Rendering(SSR)
              and Static Site Generation(SSG). Today I will talk about SSG.
            </p>
            <br />
            <p>
              <b>Static Site Generation(SSG):</b> It means generating a static
              website. We can generate a static site with two packages
              React-Helmet and React-Snap. The React-Helmet generate
              &lt;title&gt; and &lt;meta&gt; tag dynamically and the React-Snap
              generates static website.
            </p>
            <br />
            <p>
              But there is a problem with that. It just works on static routes.
              If we have some dynamic data then it won t work on that pages.
            </p>
            <br />
            <p>
              <b>What is the best Solution For that?</b>
            </p>
            <p>
              The best possible solution is to use Next Js. It generates every
              page like the static page. And It solves everything. It is very
              good for SEO. And loads website very fast.
            </p>
          </article>
        </Container>
      </div>
    </div>
  );
};

export default Blog2;
